import {PolicyRepository} from '../../../repositories/policy.repository';
import {Constants} from '../../../models/constants/marketplace.constants';

export class PolicyGateway {
    public static $inject = ['$q', 'policyRepository'];

    public constructor(private $q: ng.IQService,
                       private policyRepository: PolicyRepository) {
    }

    public loadApplicablePoliciesByBrand(brandId: string, policyEffectiveDate: Date): ng.IPromise<any> {
        return this.policyRepository.getPoliciesByBrand(brandId, policyEffectiveDate).then((result: number[]) => {
            return result;
        });
    }

    public isDeliveryAutoApplicable(applicablePolicies: number[]): boolean {
        if (angular.isUndefined(applicablePolicies)) {
            // if the promise hasn't finished yet, assume the policy isn't applicable (so it will hide from the nav by default, for example)
            return false;
        }
        return applicablePolicies.some((x) => x === Constants.ProductLine.IntrepidDeliveryAuto);
    }
}